export const TOOLBAR_FORM = 'MANAGE_CHILDREN_TOOLBAR_FORM';
export const ADD_CHILD_FORM = 'MANAGE_CHILDREN_ADD_CHILD_FORM';
export enum TOOLBAR_SHOW_OPTIONS {
    CURRENT = 'CURRENT',
    FUTURE = 'FUTURE',
    PAST = 'PAST',
}
export enum SORT_KEYS {
    CHILD_NAME = 'CHILD_NAME',
    START_DATE = 'START_DATE',
    DOB = 'DOB',
    ROOM = 'ROOM',
}
